import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useActions as useDispatchActionHook } from 'common/hooks/use-actions';

import { ABTest, PageStoreState, TWindowType, WindowTypes } from './types';
import { getScreenType, isBrowser } from '../../utils';

export const initialState: PageStoreState = {
	windowType: getScreenType((isBrowser() && window.innerWidth) || 1024),
	isSmallScreen: isBrowser() && window.innerWidth < 1024,
	abTesting: {},
};

const pageStoreSlice = createSlice({
	name: 'pageStore',
	initialState,
	reducers: {
		setWindowType(state, action: PayloadAction<TWindowType>) {
			state.windowType = action.payload;
			state.isSmallScreen =
				action.payload === WindowTypes.tablet || action.payload === WindowTypes.mobile;
		},
		setABVariant(state, action: PayloadAction<ABTest>) {
			state.abTesting = { ...state.abTesting, ...action.payload };
		},
	},
});

export const {
	actions: pageStoreActions,
	reducer: pageStoreReducer,
	name: pageStoreName,
} = pageStoreSlice;

export const { setWindowType, setABVariant } = pageStoreActions;

export const useDispatchAction = () => useDispatchActionHook(pageStoreActions);
